import axiosInstanceWee, { axiosIntanceVinco } from './api-config';

import { REGISTER_PASOS_URL } from '../constants/constants';

export const registerProgressInBackend = async (idPersona, codPasos) => {
  const postData = new URLSearchParams();
  postData.append('idPersona', idPersona);
  postData.append('codPasos', codPasos);
  postData.append('idUser', '00000000-0000-0000-0000-000000000000');
  postData.append('isCallCenter', '0');

  return axiosInstanceWee
    .post(REGISTER_PASOS_URL, postData)
    .then((resp) => resp);
};

export const logProgressInVincoBack = (
  idTramite,
  timeStampFrontend,
  stepNumber,
  codPasos,
  logType,
  httpStatus,
  httpStatusAmae,
  otherData,
  message,
) => {
  const postMessage = message ? message.split(',') : [];

  axiosIntanceVinco({
    method: 'post',
    data: {
      idTramite,
      timeStampFrontend,
      stepNumber,
      codPasos,
      logType,
      httpStatus,
      httpStatusAmae,
      otherData,
      message: postMessage,
    },
  });
};

/**
 * Strips all non numeric characters to add forward slashes and
 * format the input as a DD/MM/YYYY date with a Field input
 * from Formik.
 *
 * Usage:
 * <Field
 * name="MiFecha"
 * onChange={(event) => maskDateInput(event, setFieldValue, 'MiFecha')} />
 *
 * @param {*} event The synth event
 * @param {*} setFieldValue Formik's field value setting function
 * @param {*} fieldName The name of the field
 */
export const maskDateInput = (event, setFieldValue, fieldName) => {
  const value = event.target.value.replace(/\D/g, '');
  let newValue = '';
  if (value.length <= 2) {
    newValue = value;
  } else if (value.length > 2 && value.length <= 4) {
    newValue = `${value.slice(0, 2)}/${value.slice(2)}`;
  } else if (value.length > 4) {
    newValue = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
  }
  setFieldValue(fieldName, newValue);
};

export const formatToMoney = (value, extraCents) => {
  if (extraCents) {
    return Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  return Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const scrollToFormStart = () => {
  document
    .querySelector(window.innerWidth < 600 ? '.quoter-header' : '.scroll-anchor')
    .scrollIntoView({
      behavior: 'smooth',
    });
};
